var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modulesModal",
        title: `${_vm.isUpdate ? "Edit" : "New"} Module`,
        "content-class": "menu-bg-blue-transparent-modal mod-modal",
        centered: "",
        "hide-footer": "",
      },
      on: {
        hide: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c("div", { staticClass: "mm-form" }, [
        _c(
          "div",
          {
            staticClass: "mm-field",
            class: { "mm-field--error": _vm.missingFields.module_name },
          },
          [
            _c("label", { staticClass: "mm-label" }, [_vm._v("Module Name")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editForm.module_name,
                  expression: "editForm.module_name",
                },
              ],
              staticClass: "mm-input",
              attrs: { placeholder: "Enter module name" },
              domProps: { value: _vm.editForm.module_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.editForm, "module_name", $event.target.value)
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mm-field",
            class: { "mm-field--error": _vm.missingFields.module_description },
          },
          [
            _c("label", { staticClass: "mm-label" }, [_vm._v("Description")]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editForm.module_description,
                  expression: "editForm.module_description",
                },
              ],
              staticClass: "mm-input mm-textarea",
              attrs: { rows: "3", placeholder: "Enter description" },
              domProps: { value: _vm.editForm.module_description },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.editForm,
                    "module_description",
                    $event.target.value
                  )
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mm-field",
            class: { "mm-field--error": _vm.missingFields.module_type },
          },
          [
            _c("label", { staticClass: "mm-label" }, [_vm._v("Module Type")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editForm.module_type,
                    expression: "editForm.module_type",
                  },
                ],
                staticClass: "mm-input mm-select",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.editForm,
                      "module_type",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              [
                _c(
                  "option",
                  { attrs: { disabled: "" }, domProps: { value: null } },
                  [_vm._v("Select type...")]
                ),
                _vm._v(" "),
                _c("option", { attrs: { value: "tool" } }, [_vm._v("Tool")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "feature" } }, [
                  _vm._v("Feature"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "admin" } }, [_vm._v("Admin")]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mm-field" }, [
          _c("label", { staticClass: "mm-label" }, [_vm._v("Status")]),
          _vm._v(" "),
          _c("div", { staticClass: "mm-toggle" }, [
            _c("div", {
              staticClass: "mm-toggle-indicator",
              style: {
                transform: `translateX(${_vm.editForm.isactive ? 0 : 100}%)`,
                background:
                  _vm.moduleTypeColor[_vm.editForm.module_type] ||
                  "var(--ac-tools)",
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "mm-toggle-btn",
                class: { active: _vm.editForm.isactive },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.editForm.isactive = true
                  },
                },
              },
              [_vm._v("\n          Active\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "mm-toggle-btn",
                class: { active: !_vm.editForm.isactive },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.editForm.isactive = false
                  },
                },
              },
              [_vm._v("\n          Inactive\n        ")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mm-actions" },
          [
            _c(
              "b-button",
              {
                attrs: { variant: "primary", size: "sm" },
                on: { click: _vm.saveModuleUpdate },
              },
              [_vm._v("Save Changes")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }